import { topCreators } from '@/mocks/creators';

function formatNumber(num: number): string {
  if (num >= 10000) {
    return (num / 10000).toFixed(0) + '万';
  }
  return num.toString();
}

export default function CreatorShowcase() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            优秀创作者
          </h2>
          <p className="text-sm text-foreground-500 mt-3">平台顶尖创作者，用镜头讲述精彩故事</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topCreators.map((creator) => (
            <div
              key={creator.id}
              className="flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-[oklch(var(--primary-500)/0.3)]"
            >
              <div className="relative flex-shrink-0">
                <img
                  src={creator.avatar}
                  alt={creator.name}
                  className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover"
                  loading="lazy"
                />
                {creator.verified && (
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-[oklch(var(--primary-500))] flex items-center justify-center">
                    <i className="ri-verified-badge-fill text-background-50 text-xs"></i>
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900">{creator.name}</h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{creator.bio}</p>
                <div className="flex items-center gap-4 mt-2 text-xs text-foreground-400">
                  <span>粉丝 {formatNumber(creator.followers)}</span>
                  <span>视频 {creator.videoCount}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}